import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { AppTheme, getThemeStyle, setTheme, useMobile, } from "common-frontend-components";
import { 
// background,
// backgroundColor,
primaryColor, primaryColorDark, primaryColorLight, thumbColor } from "../../assets/styles/colors";
// -------------------
// customise app theme
// ___________________
const theme = JSON.parse(JSON.stringify(getThemeStyle()));
// @ts-ignore
theme.palette.primary.light = primaryColorLight;
// @ts-ignore
theme.palette.primary.main = primaryColor;
// @ts-ignore
theme.palette.primary.dark = primaryColorDark;
theme.colors.primary = primaryColorLight;
theme.colors.secondary = primaryColorDark;
theme.colors.btn.secondary = primaryColorLight;
theme.colors.btn.primary_focused = primaryColor;
theme.colors.btn.secondary_focused = primaryColorDark;
theme.colors.btn.gradient1 = primaryColor;
theme.colors.btn.gradient2 = primaryColorLight;
theme.colors.scrollbarTrack = `${primaryColorLight}55`;
// @ts-ignore
const global = theme.overrides.MuiCssBaseline['@global'];
const root = global['#root'];
const body = global.body;
// global['*'] = {
//   backgroundColor,
// }
root.backgroundColor = /*backgroundColor*/ "transparent";
body.backgroundColor = /*backgroundColor*/ "transparent";
setTheme(theme);
const useThemeResponsive = () => {
    const isMobile = useMobile();
    useEffect(() => {
        // tslint:disable-next-line:no-shadowed-variable
        const theme = JSON.parse(JSON.stringify(getThemeStyle()));
        // @ts-ignore
        if (theme.overrides?.MuiCssBaseline['@global']) {
            // @ts-ignore
            theme.overrides.MuiCssBaseline['@global'] = { ...theme.overrides?.MuiCssBaseline['@global'] };
            // @ts-ignore
            // tslint:disable-next-line:no-shadowed-variable
            const global = theme.overrides?.MuiCssBaseline['@global'];
            const scrollbarThumb = {
                backgroundColor: thumbColor,
                backgroundImage: 'linear-gradient(90deg, #273f7288, #030509A5)',
                borderRadius: '7px',
            };
            const scrollbar = {
                width: '15px',
                backgroundColor: "rgba(3,5,9,0.65)",
            };
            if ([true, null].includes(isMobile)) {
                // scrollbar.width = '12px';
            }
            global['*::-webkit-scrollbar-thumb'] = scrollbarThumb;
            global['*::-webkit-scrollbar'] = scrollbar;
            setTheme(theme);
        }
    }, [isMobile]);
};
export const ThemeProvider = ({ children }) => {
    useThemeResponsive();
    return (_jsx(AppTheme, { children: children }, void 0));
};
//# sourceMappingURL=ThemeProvider.js.map